import { observer } from "mobx-react";
import { useStores } from "../../../../..";
import { DeleteDefaultButton } from "../../../../../Components/IconButtons";

import { LearningPathStore } from "../../../../../Stores/LearningPathStores/LearningPathStore";
import TreeNodeApi from "./TreeNodeApi";
import { TreeNode } from "./TreeNode";
import { LearningPathResourceResponseApi } from "../../../../../DTO/ServerResponseType/LearningPath/LearningPathResource";

const getResourceNode = (
  learningPathStore: LearningPathStore,
  learningPathResource: LearningPathResourceResponseApi
): TreeNodeApi => {
  return {
    value: learningPathResource.learningPathResourceId,
    label: (
      <ResourceNode
        learningPathStore={learningPathStore}
        learningPathResource={learningPathResource}
      />
    ),
  };
};

const ResourceNode: React.FC<{
  learningPathStore: LearningPathStore;
  learningPathResource: LearningPathResourceResponseApi;
}> = observer(({ learningPathStore, learningPathResource }) => {
  let learningPathWindowStore = useStores().learningPathWindowStore;

  return (
    <TreeNode
      label={<li>{learningPathResource.resource.resourceName}</li>}
      buttons={
        <>
          {learningPathStore.doSave && (
            <DeleteDefaultButton
              withShadow={false}
              onClick={() => {
                learningPathWindowStore.onDeleteModalToDeleteLearningPathResourceOpen(
                  learningPathStore.learningPath,
                  learningPathResource.resource
                );
              }}
            />
          )}
        </>
      }
    />
  );
});

export default getResourceNode;
